const getHtmlFromRedactorField = (field) => {
	if (!field) {
		return null;
	}
	return { __html: `<div class="custom-redactor" x-ms-format-detection="none">${field}</div>` };
};

export default getHtmlFromRedactorField;
